import type { ArticleBarChartBar } from '~/modules/landing/interfaces';

export function getArticleBarChartRatios(bars: Array<ArticleBarChartBar>): Array<number> {
    const highestAmount = Math.max(0, ...bars.map((bar) => bar.amount));

    if (highestAmount <= 0) {
        return bars.map(() => 0);
    }

    return bars.map((bar) => bar.amount / highestAmount);
}
